
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServiceDetailLayout from "@/components/features/services/ServiceDetails";
import NotFound from "../NotFound";
import { fetchService } from "@/services/services-api";
import { useLanguage } from "@/contexts/LanguageContext";
import type { ServiceData } from "@/types/services";

const ServiceDetail = () => {
  const { serviceId: urlServiceId } = useParams<{ serviceId: string }>();
  const { language } = useLanguage();
  const [serviceData, setServiceData] = useState<ServiceData | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!urlServiceId) return;

    let active = true;
    setLoading(true);
    setNotFound(false);

    fetchService(urlServiceId, language)
      .then((service) => active && setServiceData(service))
      .catch(() => active && setNotFound(true))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [language, urlServiceId]);

  if (!urlServiceId) {
    return <NotFound />;
  }

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center">Loading service…</div>;
  }

  if (notFound || !serviceData) {
    return <NotFound />;
  }

  return (
    <ServiceDetailLayout
      serviceId={serviceData.id}
      icon={serviceData.icon}
      color={serviceData.color}
      bgColor={serviceData.bgColor}
      serviceData={{
        title: serviceData.title,
        description: serviceData.description,
        labels: serviceData.labels,
        process: serviceData.process || [],
        bestPractices: serviceData.bestPractices || [],
      }}
    />
  );
};

export default ServiceDetail;
